
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[handle]/reviews",
      function () {
        return require("private-next-pages/products/[handle]/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[handle]/reviews"])
      });
    }
  